import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import moment from 'moment';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';

import { useStyles } from './useStyles';
import { Typography } from '../material-ui/Typography';
import { getCurrentDutyInfo } from '../../selectors/sended-data';

export const DutyTimeCounter = memo(({ showLabel = true }) => {
    const { dutyTime, startWorkTime } = useSelector(getCurrentDutyInfo);
    const [currentDutyTime, changeDutyTime] = React.useState();
    const shortView = useMediaQuery('(max-width: 700px)');
    const classes = useStyles();
    const { t: translate } = useTranslation();

    const handleTick = React.useCallback(() => {
        const currentTime = moment.utc();
        if (startWorkTime && startWorkTime.isBefore(currentTime)) {
            const time = dutyTime + currentTime.diff(startWorkTime, 'minute');
            changeDutyTime(moment.utc('20100101').add(time, 'minute').format('HH:mm'));
        } else if (dutyTime) {
            const time = moment.utc('20100101').add(dutyTime, 'minute');
            changeDutyTime(time.format('HH:mm'));
        } else {
            changeDutyTime('--:--');
        }
    }, [dutyTime, startWorkTime]);

    React.useEffect(() => {
        const timer = setInterval(handleTick, 1000);

        return () => clearInterval(timer);
    }, [handleTick]);

    if (!currentDutyTime) {
        return null;
    }

    return (
        <Typography className={classes.text}>
            {!showLabel || shortView ? '' : translate('labels.curDuteTime')}
            <span className={classes.dutyTime}>{currentDutyTime}</span>
        </Typography>
    );
});

DutyTimeCounter.displayName = 'DutyTimeCounter';
